/* ============================================================
   Native Cart Discount Handler (Spitzbub)
   Uses /cart/update.js { discount: "CODE" } (Shopify Summer '25)
   Single cart system — no Storefront API needed
   ============================================================ */

(function () {
  'use strict';

  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code || '' })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      return res.json();
    });
  }

  function removeDiscount() {
    return applyDiscount('');
  }

  function refreshDrawer() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return Promise.resolve();

    var cartItems = document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate();
    }

    return fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['cart-drawer-items', '.drawer__footer'];
        selectors.forEach(function (sel) {
          var newEl = doc.querySelector(sel);
          var oldEl = document.querySelector(sel);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      });
  }

  function applyAndRefresh(code) {
    return applyDiscount(code).then(function (cart) {
      return refreshDrawer().then(function () { return cart; });
    });
  }

  function removeAndRefresh() {
    return removeDiscount().then(function (cart) {
      return refreshDrawer().then(function () { return cart; });
    });
  }

  function detectDiscountUrl() {
    var match = window.location.pathname.match(/\/discount\/([^/?#]+)/i);
    if (match) {
      var code = decodeURIComponent(match[1]);
      applyDiscount(code);
    }
  }

  detectDiscountUrl();

  window.CartDiscount = {
    apply: applyDiscount,
    remove: removeDiscount,
    applyAndRefresh: applyAndRefresh,
    removeAndRefresh: removeAndRefresh,
    refreshDrawer: refreshDrawer
  };
})();
